// extracted by mini-css-extract-plugin
export default {"root":"UserImage_root__6qlU3","withIcon":"UserImage_withIcon__SX+tq","withInitials":"UserImage_withInitials__45YQM","initials":"UserImage_initials__Mq5iv"};